<div class=" h-100 t2 c-primary-gray-900" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="12px">
    <mat-expansion-panel class="w-100">
        <mat-expansion-panel-header class="w-100"
                                    fxLayout="start start">
            <mat-panel-title class="no-wrap t2-semi-bold"> {{ 'i18n_af_labelApprovedOrder' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        <af-file-group-preview [attachments]="attachments"/>
    </mat-expansion-panel>
</div>
